import React, { useState, useEffect, Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { withRouter, Redirect, Link } from "react-router-dom";
import _ from "underscore";
import AppWrapper from "../Common/AppWrapper";
import Loading from "../Common/Misc/Loading";
import ResultsTable from "./ResultsTable.jsx";
import * as data from "../../sampleData/get_history_response.json";
import "./MySearch.scss";
import * as help from "../../i18n/en/help.json";
import * as assayActions from "../../actions/assays";
import * as constants from "../../i18n/en/assay.json";
import Chip from "@material-ui/core/Chip";
import {
  formatAssayApplicationType,
  processSearchParameter,
} from "../../util/format";
const AssaySearch = (props) => {
  const searchStringFromProps = processSearchParameter(
    (props &&
      props.location &&
      props.location.search !== "" &&
      props.location.search.replace("?", "").trim()) ||
      ""
  );
  const { actions, searchData, pageLoading } = props;

  const [searchString, setSearchString] = useState("");
  const fetchResults = (searchStringFromProps) => {
    actions.fetchAssaySearchResult(searchStringFromProps);
  };

  // Change the data from props when integrated.

  const resultData =
    (searchData && searchData.data && searchData.data.data) || [];

  const responseCode = searchData && searchData.status;

  //const resultData = [];
  useEffect(() => {
    if (searchStringFromProps && searchStringFromProps !== searchString) {
      setSearchString(searchStringFromProps);
      fetchResults(searchStringFromProps);
    }
  }, [searchStringFromProps]);
  const assayTypes = _.keys(constants.assay.applicationType);
  let processedData = {};
  resultData &&
    _.map(
      assayTypes,
      (i) =>
        (processedData[i] = _.filter(resultData, (e) => {
          return e.assayType === i;
        }))
    );
  const keys = _.keys(processedData);


  const noSearchResults =
    help && help.contextHelp && help.contextHelp.searchResults.termNotFound;
  const emptySearchString =
    help &&
    help.contextHelp &&
    help.contextHelp.searchResults.emptySearchString;

  return (
    <AppWrapper id="assay-search-page">
      {pageLoading && <Loading isLoading={pageLoading} />}
      {!pageLoading && !!(searchString === "") && (
        <div
          id="empty-search-string"
          className="alert alert-danger d-flex justify-content-center"
        >
          {emptySearchString}
        </div>
      )}
      {!pageLoading &&
        searchString &&
        responseCode === 200 &&
        !!(searchString !== "") &&
        resultData &&
        !_.isEmpty(resultData) && (
          <div className="container main-content" id="search-results">
            <h4 className="d-flex justify-content-center">{`Search Results for ${searchString}`}</h4>
            <br />
            <div className="d-flex  row justify-content-center">
              {_.map(assayTypes, (value,key) => {
                if (!_.isEmpty(processedData[value])) {
                  return (
                    <div key={key} className="col-auto">
                      <Chip
                        className="outlined"
                        label={formatAssayApplicationType(value)}
                        component="a"
                        href={`#${value}`}
                        clickable
                        variant="outlined"
                      />
                    </div>
                  );
                }
              })}
            </div>
            <br />
            {_.map(assayTypes, (value) => {
              if (!_.isEmpty(processedData[value])) {
                return (
                  <React.Fragment key={value}>
                    <h4 id={value} className="d-flex justify-content-start">
                      {formatAssayApplicationType(value)}
                    </h4>
                    <br />
                    <ResultsTable data={processedData[value]} {...props} />
                    <br />
                  </React.Fragment>
                );
              }
            })}
          </div>
        )}
      {!pageLoading &&
        searchString &&
        responseCode === 200 &&
        !!(searchString !== "") &&
        _.isEmpty(resultData) && (
          <div
            id="no-search-results"
            className="alert alert-danger d-flex justify-content-center"
          >
            {noSearchResults}
          </div>
        )}
    </AppWrapper>
  );
};

const stateToProps = (state, props) => ({
  searchData: (state.assays && state.assays.searchResults) || [],
  pageLoading: (state.assays && state.assays.pageLoading) || false,
});

const dispatchToProps = (dispatch) => ({
  actions: bindActionCreators(assayActions, dispatch),
});

export default withRouter(connect(stateToProps, dispatchToProps)(AssaySearch));
